import { render, staticRenderFns } from "./ImpactDetailCard.vue?vue&type=template&id=c2a9e466&"
import script from "./ImpactDetailCard.vue?vue&type=script&lang=js&"
export * from "./ImpactDetailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports